module.exports = __webpack_public_path__ + "static/media/icon-2.e2140119.png";